import FloatingSidebar from './code/Scripts/Components/FloatingSidebar.vue';

export default {
  components: {
    FloatingSidebar,
  },
};
